import React from 'react';
import PropTypes from 'prop-types';
import { observable } from "mobx";
import { observer } from 'mobx-react';
import Grid from '@material-ui/core/Grid';
import Skeleton from '@material-ui/lab/Skeleton';

import Header from '../../components/utils/Header';
import Scenario from '../../api/Scenario';
import ScenarioForm from './ScenarioForm';


@observer
class ScenarioCopyView extends React.Component {
  static propTypes = {
    instanceId: PropTypes.number,
  };

  @observable scenario = null;

  async componentDidMount() {
    const originalScenario = await Scenario.asyncGetForId(this.props.instanceId);
    this.scenario = await originalScenario.copyInstance();
  }

  render() {
    if (this.scenario === null || !this.scenario.isFetched) {
      return <Skeleton variant="rect" height={500} />;
    }
    const { instanceId } = this.props;
    return (
      <Grid container direction="column" spacing={2} wrap="nowrap">
        <Grid item>
          <Header title={`Copy “${Scenario.getForId(instanceId).toString()}”`} />
        </Grid>
        <Grid item>
          <ScenarioForm instance={this.scenario} refScenarioId={this.props.instanceId} />
        </Grid>
      </Grid>
    );
  }
}


export default ScenarioCopyView;
